import { memo, useEffect } from 'react'
import PropTypes from 'prop-types'

const ScriptTag = props => {
	useEffect(() => {
		const { children, onLoad, onError, ...rest } = props
		if (props.src && document.querySelector(`script[src="${props.src}"]`)) {
			onLoad?.()
			return
		}

		const script = document.createElement('script')
		const attribs = Object.entries(rest)
		attribs.forEach(([key, value]) => {
			script[key] = value
		})
		script.innerText = children
		script.async = false
		script.onload = onLoad
		script.onerror = onError
		document.body.appendChild(script)
	}, [props])

	return null
}

ScriptTag.propTypes = {
	children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	onLoad: PropTypes.func,
}

export default memo(ScriptTag)
